"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoadshedLayers = exports.SET_LOADSHED_LAYERS = exports.getUsersLayers = exports.GET_USER_LAYERS_FAILURE = exports.GET_USER_LAYERS_SUCCESS = exports.GET_USER_LAYERS_REQUEST = void 0;

var _api = require("../middleware/api");

var _loadshedData = require("../api/loadshedData");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GET_USER_LAYERS_REQUEST = 'GET_USER_LAYERS_REQUEST';
exports.GET_USER_LAYERS_REQUEST = GET_USER_LAYERS_REQUEST;
var GET_USER_LAYERS_SUCCESS = 'GET_USER_LAYERS_SUCCESS';
exports.GET_USER_LAYERS_SUCCESS = GET_USER_LAYERS_SUCCESS;
var GET_USER_LAYERS_FAILURE = 'GET_USER_LAYERS_FAILURE';
exports.GET_USER_LAYERS_FAILURE = GET_USER_LAYERS_FAILURE;

var getUsersLayers = function getUsersLayers(url, callback, errorCallback) {
  return _defineProperty({}, _api.CALL_API, {
    types: [GET_USER_LAYERS_REQUEST, GET_USER_LAYERS_SUCCESS, GET_USER_LAYERS_FAILURE],
    request: function request() {
      return (0, _loadshedData.getLayerMetadataFile)(url);
    },
    callback: callback,
    errorCallback: errorCallback
  });
};

exports.getUsersLayers = getUsersLayers;
var SET_LOADSHED_LAYERS = 'SET_LOADSHED_LAYERS';
exports.SET_LOADSHED_LAYERS = SET_LOADSHED_LAYERS;

var setLoadshedLayers = function setLoadshedLayers(layers) {
  return {
    type: SET_LOADSHED_LAYERS,
    loadshedLayers: layers
  };
};

exports.setLoadshedLayers = setLoadshedLayers;